import React from "react";

const serviceLabel = (available) => {
  if (available === true) return "Yes";
  if (available === false) return "No";
  return "Not set";
};

const CustomerSleepServices = ({ customer }) => {
  const hasRoomCount = Number.isSafeInteger(customer.hospitalRoomCount) && customer.hospitalRoomCount > 0;

  return (
    <div className="node-card__sleep-services">
      <div className={`node-service node-service--${customer.hospitalSleepAvailable === true ? "yes" : customer.hospitalSleepAvailable === false ? "no" : "unset"}`}>
        Sleep in Hospital: <span>{serviceLabel(customer.hospitalSleepAvailable)}</span>
        {customer.hospitalSleepAvailable === true && hasRoomCount && (
          <span> · {customer.hospitalRoomCount} {customer.hospitalRoomCount === 1 ? "room" : "rooms"}</span>
        )}
      </div>
      <div className={`node-service node-service--${customer.homeSleepAvailable === true ? "yes" : customer.homeSleepAvailable === false ? "no" : "unset"}`}>Home Sleep: <span>{serviceLabel(customer.homeSleepAvailable)}</span></div>
      <div className={`node-service node-service--${customer.opdDoctorVisitAvailable === true ? "yes" : customer.opdDoctorVisitAvailable === false ? "no" : "unset"}`}>OPD Doctor Visit: <span>{serviceLabel(customer.opdDoctorVisitAvailable)}</span></div>
    </div>
  );
};

export default CustomerSleepServices;
